/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Section } from './Section.js';
import {
    SectionFromJSON,
    SectionFromJSONTyped,
    SectionToJSON,
} from './Section.js';

/**
 * 
 * @export
 * @interface SectionSingleResponse
 */
export interface SectionSingleResponse {
    /**
     * 
     * @type {Section}
     * @memberof SectionSingleResponse
     */
    data?: Section;
    /**
     * 
     * @type {number}
     * @memberof SectionSingleResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof SectionSingleResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SectionSingleResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof SectionSingleResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the SectionSingleResponse interface.
 */
export function instanceOfSectionSingleResponse(value: object): boolean {
    return true;
}

export function SectionSingleResponseFromJSON(json: any): SectionSingleResponse {
    return SectionSingleResponseFromJSONTyped(json, false);
}

export function SectionSingleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionSingleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SectionFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function SectionSingleResponseToJSON(value?: SectionSingleResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': SectionToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

